/**
 * @generated SignedSource<<048f4230fddb84b53a850720b55b3be2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CourseVisibility = "MEMBER_ONLY" | "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type cursosHeadQuery$variables = {
  club: string;
  course: string;
};
export type cursosHeadQuery$data = {
  readonly club: {
    readonly course: {
      readonly description: any | null | undefined;
      readonly landscapeImage: {
        readonly signedUrl: string;
      } | null | undefined;
      readonly name: string;
      readonly updatedAt: any;
      readonly visibility: CourseVisibility;
    };
    readonly name: string;
  };
};
export type cursosHeadQuery = {
  response: cursosHeadQuery$data;
  variables: cursosHeadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "course"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "course"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cursosHeadQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageFile",
                "kind": "LinkedField",
                "name": "landscapeImage",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cursosHeadQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageFile",
                "kind": "LinkedField",
                "name": "landscapeImage",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a056269dce0e5a13269d65157fd0512",
    "id": null,
    "metadata": {},
    "name": "cursosHeadQuery",
    "operationKind": "query",
    "text": "query cursosHeadQuery(\n  $club: String!\n  $course: String!\n) {\n  club(slug: $club) {\n    name\n    course(slug: $course) {\n      name\n      description\n      landscapeImage {\n        signedUrl\n        id\n      }\n      visibility\n      updatedAt\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3efe4e9ae2d6ec310f61dc35822d83dd";

export default node;
